import axios from "../../../util/axios";

const PREFIX_URI = "/wx/checkin";

/**
 * 考勤统计接口（企业微信打卡）
 *
 * 数据来源是企业微信打卡接口，同步后落在 qw_check_in_detail / qw_check_in_info。
 * 查询时会先看「该商户今天是否已同步过」，没同步过就先拉一次企微。
 */
export default {
    /** 查询考勤日历：时间范围内一天一格 */
    queryCalendar: (data) => axios.get({url: `${PREFIX_URI}/queryCalendar`, data}),
    /** 查询某天的打卡明细（抽屉用） */
    queryDayDetail: (date) => axios.get({url: `${PREFIX_URI}/queryDayDetail`, data: {date}}),
}
